import React from 'react';
import { ShieldAlert } from 'lucide-react';

/**
 * DeviceUnauthorized — Sperrbildschirm, wenn das Backend mit 403 antwortet,
 * weil entweder kein Token, ein widerrufenes Token oder ein Standort-
 * Mismatch vorliegt. Wird von ShiftsTVView und TimeTrackingTerminal
 * conditionally angezeigt.
 */
export default function DeviceUnauthorized({ reason }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white p-6">
      <div className="max-w-md text-center" data-testid="device-unauthorized">
        <div className="w-20 h-20 rounded-2xl bg-amber-500/20 flex items-center justify-center mx-auto mb-6">
          <ShieldAlert className="h-10 w-10 text-amber-400" />
        </div>
        <h1 className="text-2xl font-bold mb-2">Gerät nicht autorisiert</h1>
        <p className="text-gray-400 leading-relaxed mb-4">
          Dieses Gerät ist nicht für die Anzeige autorisiert.
          {reason ? <span className="block mt-2 text-sm text-gray-500">({reason})</span> : null}
        </p>
        <p className="text-sm text-gray-500">
          Bitte kontaktiere deine:n Administrator:in, um eine neue
          Geräte-Pairing-URL zu erhalten.
        </p>
      </div>
    </div>
  );
}
